import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SurveyService } from '../../../service/survey.service';
import { MessageService } from 'src/app/service/message.service';
import { SurveyForList } from 'src/app/model/survey-response';

@Component({
  selector: 'final',
  templateUrl: './final.component.html'
})
export class FinalComponent {
  @Input() surveyId!: string;
  @Output() complete = new EventEmitter<SurveyForList>();

  loading: boolean = false;
  completed: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private messageService: MessageService
  ) {}

  onSubmit() {
    this.loading = true;
    this.completed = true;

    this.surveyService.completeSurvey(this.surveyId).subscribe({
      next: (surveyInfo: SurveyForList) => {
        this.loading = false;
        this.complete.emit(surveyInfo);
      },
      error: () => {
        this.messageService.error('survey.new.message.unknown-error');
        this.loading = false;
        this.completed = false;
      }
    });
  }
}
